import { createContext, useEffect, useReducer, useState } from "react";
import { initialState, productsReducer } from "../../../store/productsReducer";
import {
  getAllCategoriesService,
  getAllProductsService,
} from "../../../api/apiServices";
import {
  actionTypes,
  addressTypes,
  filterTypes,
} from "../../../utils/actionTypes";
import { useAuthContext } from "..";
import services from '../../../services'
import { notify } from "../../../utils/utils";
import commonObj from '../../../utils/Common';

export const ProductsContext = createContext();

const ProductsContextProvider = ({ children }) => {
  const { token, userinfo } = useAuthContext();
  const [loading, setLoading] = useState(false);

  const [state, dispatch] = useReducer(productsReducer, initialState);
  const [currentAddress, setCurrentAddress] = useState(state.addressList[0]);
  const [isOrderPlaced, setisOrderPlaced] = useState(false);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        /*
          const productsRes = await services.productService.getProductList({parent:params?.catId})
          console.log(productsRes)
         if (productsRes.status === 1) {
            dispatch({
              type: actionTypes.INITIALIZE_PRODUCTS,
              payload: productsRes.data.products,
            });
          }
        */
        const categoryRes = await services.categoryService.getCategorylist({filter:{parent:0,status:1}});
        if (categoryRes.status === 1) {
          dispatch({
            type: actionTypes.INITIALIZE_CATEGORIES,
            payload: categoryRes.data,
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const getProductById = (productId) =>
    state.allProducts.find((product) => product.id === productId);

  const updateInCartOrInWish = (productId, type, value) => {
    if (productId) {
      dispatch({
        type: actionTypes.UPDATE_PRODUCTS,
        payload: state.allProducts.map((item) =>
          item.id === productId ? { ...item, [type]: value } : item
        ),
      });
    } else {
      dispatch({
        type: actionTypes.UPDATE_PRODUCTS,
        payload: state.allProducts.map((item) => ({
          ...item,
          inCart: false,
          qty: 0,
        })),
      });
    }
  };

  const applyFilters = (filterType, filterValue) => {
    dispatch({
      type: filterTypes.FILTERS,
      payload: { filterType, filterValue },
    });
  };
  const clearFilters = () => {
    dispatch({
      type: filterTypes.CLEAR_FILTER,
    });
  };
  const trendingProducts = state.allProducts.filter(
    (product) => product.trending
  );

  const addAddress = (newAddress) => {
    setLoading(true);
    (async ()=>{
      try {
        const categoryRes = await services.addressService.addAddress(newAddress);
        if (categoryRes.status === 1) {
          dispatch({
            type: addressTypes.ADD_ADDRESS,
            payload: [newAddress, ...state.addressList],
          });
          notify('success', commonObj.getLabel('Address_Added'))
        }else{
          notify('error', commonObj.getLabel('Something_went_wrong'))
        }
      }catch(e){

      }finally {
        setLoading(false);
      }
    })()
  };

  const updateAddress = (addressId, updatedAddress) => {
    setLoading(true);
    (async ()=>{
      try {
        const categoryRes = await services.addressService.updateAddress(addressId, updatedAddress);
        if (categoryRes.status === 1) {
          dispatch({
            type: addressTypes.ADD_ADDRESS,
            payload: state.addressList.map((item) =>
              item.id === addressId ? updatedAddress : item
            ),
          });
          if (currentAddress.id === addressId) {
            setCurrentAddress(updatedAddress);
          }
          notify('success', commonObj.getLabel('Address_Updated'))
        }else{
          notify('error', commonObj.getLabel('Something_went_wrong'))
        }
      }catch(e){

      }finally {
        setLoading(false);
      }
    })()
   
  };

  const deleteAddress = (addressId) => {
    setLoading(true);
    (async ()=>{
      try {
        const categoryRes = await services.addressService.deleteAddress(addressId);
        if (categoryRes.status === 1) {
          dispatch({
            type: addressTypes.ADD_ADDRESS,
            payload: state.addressList.filter(({ id }) => id !== addressId),
          });
          if (currentAddress.id === addressId) {
            setCurrentAddress({});
          }
          notify('success', commonObj.getLabel('Address_Deleted'))
        }else{
          notify('error', commonObj.getLabel('Something_went_wrong'))
        }
      }catch(e){

      }finally {
        setLoading(false);
      }
    })()
    
    
  };

  const isInCart = (productId) =>{
    console.log(state.cart,'ddddaaa')
    state.allProducts.find((item) => item.id === productId && item.inCart);
  }

  const isInWish = (productId) =>
    state.allProducts.find((item) => item.id === productId && item.inWish);

const setDefaultAddress = async (addressId, userId, address) => {
   const categoryRes = await services.addressService.updateAddress(addressId, {type:'setDefault',userId:userId});
   setCurrentAddress(address)
   if (categoryRes.status === 1) {
    notify('success', commonObj.getLabel('Default_Address_Updated'))
  }else{
    notify('error', commonObj.getLabel('Something_went_wrong'))
  }
}

  return (
    <ProductsContext.Provider
      value={{
        allProducts: state.allProducts,
        wishlist: state.wishlist,
        filters: state.filters,
        maxRange: state.maxRange,
        categoryList: state.categoryList,
        addressList: state.addressList,
        isInCart,
        isInWish,
        isOrderPlaced,
        currentAddress,
        loading,
        trendingProducts,
        updateInCartOrInWish,
        getProductById,
        applyFilters,
        clearFilters,
        addAddress,
        updateAddress,
        deleteAddress,
        setCurrentAddress,
        setisOrderPlaced,
        setDefaultAddress,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

export default ProductsContextProvider;
